import { z } from 'zod';
import { parseApiReserve, type ApiReserveView } from '../../../shared/api-reserve';
const State = z.enum(['active', 'inactive', 'unavailable']);
const ResponseSchema = z.object({ reserve: z.unknown(), bridges: z.object({ dev: State, prod: State }), reason: z.string().nullable() });
/** Validate the entire response before financial data reaches the component. */
export async function readApiReserve(signal: AbortSignal): Promise<ApiReserveView | 'forbidden'> {
  const response = await fetch('/api/bridge/api-reserve', { signal, cache: 'no-store' });
  if (response.status === 403) return 'forbidden';
  if (!response.ok) throw new Error(`API reserve HTTP ${response.status}`);
  const data = ResponseSchema.parse(await response.json());
  return { reserve: parseApiReserve(data.reserve), bridges: data.bridges, reason: data.reason };
}
